import { render } from "./SelectPurchaseItem.vue?vue&type=template&id=15a4979a"
import script from "./SelectPurchaseItem.vue?vue&type=script&lang=js"
export * from "./SelectPurchaseItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__